import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 204,
  name: 'No Content',
  description:
    'The request succeeded but there is no response body to return. The server processed the request and intentionally sends back an empty body. Common after DELETE operations or form submissions that need no confirmation payload.',
  causes: [
    'A DELETE request successfully removed a resource. The server confirms deletion but has nothing to return.',
    'A PUT or PATCH request updated a resource and the server chose not to return the updated representation.',
    'A form submission or action endpoint completed successfully but the client does not need any response data.',
  ],
  fixes: [
    'No fix needed — 204 is a valid success response. If your client expects a body, either update the client to handle empty responses or change the server to return 200 with a body.',
    'Do not set a Content-Type or Content-Length header when returning 204 — the response must not contain a body per the HTTP spec.',
    'If your frontend fetch call fails on 204, check that you are not calling response.json() unconditionally. Guard it with a status code check.',
  ],
  monitoringTip:
    'Uptrack treats 204 as a successful response. If your DELETE or update endpoint suddenly returns a 5xx instead of 204, Uptrack will catch it and alert you.',
}

export const Route = createFileRoute('/_site/http/204')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
